import { render, staticRenderFns } from "./ReceiveLines.vue?vue&type=template&id=38ca4720&scoped=true"
import script from "./ReceiveLines.vue?vue&type=script&lang=js"
export * from "./ReceiveLines.vue?vue&type=script&lang=js"
import style0 from "./ReceiveLines.vue?vue&type=style&index=0&id=38ca4720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ca4720",
  null
  
)

export default component.exports